module.exports = __webpack_public_path__ + "static/media/bold_cross_icon.f3fa03bb.svg";